export const getParameterByName = (name: string, url?: string) => {

    // Silly to roll our own, I know, but we need the name lookup to be case insensitive,
    // and I didn't want to loop through keys
    if (!url) {
        url = window.location.href;
    }

    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'i');
    var results = regex.exec(url);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
};